<template>
  <div class="mt-2">
    <div class="d-flex">
    <h4>{{ $t("message.checkoutDelivery") }} {{ $t("message.address") }}</h4>
    <b-icon-plus style="margin-top: 0.1rem;" v-if="!deliveryVisible" @click="deliveryVisible = true"></b-icon-plus>
    <b-icon-dash style="margin-top: 0.1rem;" v-else @click="deliveryVisible = false"></b-icon-dash>
    </div>
    <b-collapse id="collapse-2" v-model="deliveryVisible" visible>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label v-if="!isRolldStore()" class="required" for="addressinput">{{
          $t("message.streetAddress")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="
            editModel.StreetAddress
              ? 'd-none'
              : !userMode
              ? 'required rolld'
              : ''
          "
          for="OO_addressinput"
        ></label>
        <vue-google-autocomplete
          id="OO_addressinput"
          name="OO_addressinput"
          ref="gAutoComplete"
          :enable-geolocation="true"
          :class="
            isDeliveryAddressValid || userMode
              ? 'form-control'
              : 'form-control invaliddatetime'
          "
          @change="addressChanged"
          @placechanged="getAddressData"
          :country="['au']"
          :disabled="getDeliveryIsLoading"
          :placeholder="
            isRolldStore()
              ? $t('message.streetAddress')
              : getStartTypingPlaceholder
          "
        />
        <div v-if="!isAddressInputValid && !userMode" class="text-danger pt-1">
          {{ $t("message.streetAddressRequired") }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-6 col-sm-4">
        <label v-if="!isRolldStore()" class="required" for="Postcode">{{
          $t("message.postcode")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.PostalCode ? 'd-none' : 'required rolld'"
          for="postcode"
        ></label>
        <input
          v-validate="'required|numeric|length:4'"
          id="postInput"
          :placeholder="isRolldStore() ? $t('message.postcode') : ''"
          v-model="editModel.PostalCode"
          name="postcode"
          @change="validatePostcode(editModel.PostalCode)"
          @blur="updateDeliveryAddress()"
          type="text"
          class="form-control"
          :disabled="isRolldStore() && isDoorDashEnabled ? true : getDeliveryIsLoading"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
        </div>
        <div class="text-danger pt-1" v-if="!isDeliveryAreaValid">
          {{ $t("message.deliveryNotAvailableFor") }} {{ editModel.PostalCode }}
        </div>
      </div>
      <div class="form-group col-6 col-sm-4">
        <label v-if="!isRolldStore()" class="required" for="Suburb">{{
          $t("message.suburb")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.CityTown ? 'd-none' : 'required rolld'"
          for="suburb"
        ></label>
        <input
          v-validate="'required|min:3'"
          id="Suburb"
          :placeholder="isRolldStore() ? $t('message.suburb') : ''"
          v-model="editModel.CityTown"
          name="suburb"
          type="text"
          @blur="updateDeliveryAddress()"
          class="form-control"
          :disabled="isRolldStore() && isDoorDashEnabled ? true : getDeliveryIsLoading"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("suburb") | inputNameLocale("suburb") }}
        </div>
      </div>
      <div class="form-group col-sm-4">
        <label v-if="!isRolldStore()" class="required" for="State">{{
          $t("message.state")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.State ? 'd-none' : 'required rolld'"
          for="state"
        ></label>
        <select
          v-validate="'required'"
          id="State"
          :placeholder="isRolldStore() ? $t('message.state') : ''"
          name="state"
          v-model="editModel.State"
          type="text"
          ref="stateRef"
          @change="updateDeliveryAddress()"
          class="form-control"
          :disabled="isRolldStore() && isDoorDashEnabled ? true : getDeliveryIsLoading"
        >
          <option :value="''" disabled="disabled" selected="selected">
            {{ $t("message.selectYourstate") }}
          </option>
          <option v-for="(state, index) in states" :key="index" :value="state">
            {{ state }}
          </option>
        </select>
        <div class="invalid-feedback">
          {{ OOErrors.first("state") | inputNameLocale("state") }}
        </div>
      </div>
    </div>
    <div class="form-row" v-if="!isGift">
      <div class="form-group col-md-12">
        <label v-if="!isRolldStore()" for="insInput">{{
          $t("message.deliveryInstructions")
        }}</label>
        <input
          id="insInput"
          :placeholder="
            isRolldStore() ? $t('message.deliveryInstructions') : ''
          "
          v-model="editModel.DeliveryInstructions"
          type="text"
          class="form-control"
        />
      </div>
    </div>
    <div
      v-if="
        isDeliveryAreaValid &&
          deliveryDuration &&
          !getDeliveryIsLoading &&
          showEstimate &&
          !userMode &&
          !isRolldStore()
      "
    >
      <span>{{ $t("message.EstimateDeliveryTime") }}:</span>
      <span class="pl-1 fw-600">{{ deliveryDuration }}</span>
      <span class="pl-1 fw-600">{{ $t("message.minutes") }}</span>
    </div>

    <div v-if="getDeliveryIsLoading && showEstimate">
      <span>{{ $t("message.CalculatingDeliveryEstimate") }}</span>
    </div>
    </b-collapse>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../../../sharedscripts/shop/Checkout/partials/DeliveryAddress.js";
import { mapGetters, mapActions } from "vuex";
import {BIconPlus, BIconDash} from 'bootstrap-vue'

export default {
  components: {
    VueGoogleAutocomplete,
    BIconPlus,
    BIconDash
  },
  props: {
    editModel: {
      type: Object,
      default: () => {},
    },
    showEstimate: {
      type: Boolean,
      default: true,
    },
    userMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      address: {
        street_number: "",
        route: "",
        locality: "",
      },

      states: ["NSW", "VIC", "QLD", "TAS", "SA", "WA", "NT", "ACT"],
      isDeliveryAreaValid: true,
      isDeliveryAddressValid: true,
      deliveryVisible: true
    };
  },
  async created() {
    if (!this.userMode) {
      await this.applyDeliveryAddress({
        address: { ...this.editModel },
        isUpdateDeliverAddress: true,
      });
      // we should enable this down the road
      this.$emit("estimationUpdated", false);
    }
  },
  mounted() {
    if (this.editModel && this.editModel.PostalCode) {
      this.validatePostcode(this.editModel.PostalCode);
    }
  },
  updated() {
    if (this.$refs.gAutoComplete) {
      this.$refs.gAutoComplete.$refs.autocomplete.autocomplete = "none";
    }
    if (this.editModel.StreetAddress) {
      document.getElementById(
        "OO_addressinput"
      ).value = this.editModel.StreetAddress;
    }
  },

  computed: {
    ...mapGetters([
      "isGift",
      "selectedCompany",
      "getDeliveryDuration",
      "getDeliveryIsLoading",
      "deliveryFee",
    ]),
    ...shared.computed,
    deliveryDuration() {
      var dt = this.getDeliveryDuration;
      if (dt) {
        var dt2 = dt.plus({ minutes: 10 });
        return dt.toFormat("m") + " - " + dt2.toFormat("m");
      }
      return dt;
    },
    getStartTypingPlaceholder() {
      return this.$t("message.StartTyping");
    },
  },
  methods: {
    ...mapActions(["applyDeliveryAddress"]),
    ...shared.methods,
    async updateDeliveryAddress() {
      if (!this.selectedCompany.DeliveryAreaZones) {
        await this.applyDeliveryAddress({
          address: this.editModel,
          isUpdateDeliverAddress: true,
        });
      }
    },
  },
};
</script>
